import React from 'react'
import { useState,useEffect } from 'react';
import $ from'jquery';

import Header from './Header';
import Footer from './Footer';
import axios from 'axios';
function Contact() {
  

    const [isMobile, setIsMobile] = useState(false);
    const [name,setName]=useState('');
    const [developmentType, setDevelopmentType] = useState('');
    const [email, setEmail] = useState('');
    const [phone,setPhone]=useState('');
const btnDisable= !(name && email && phone && developmentType);

const [items , setItems] = useState({ name : name , email : email , phone : phone , developmentType : developmentType});
 const handleSubmit = (e) => {
    e.preventDefault();
fetch("https://coinoneglobal.com/coinone/add_user.php", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({ name, email, phone, developmentType }),
})
  .then(res => res.json())
  .then(data => alert(data.message))
  .catch(err => console.error("Error:", err));
  };
    useEffect(() => {
      window.scrollTo(0, 0);
      // Handle mobile nav toggle click
      $('.mobile-nav-toggle').on('click', function () {
        setIsMobile(!isMobile);
      });
  
      // Handle link clicks in mobile view
      $('.nav-link.scrollto').on('click', function () {
        if (isMobile) {
          setIsMobile(false);
        }
      });
  
      // Cleanup function
      return () => {
        $('.mobile-nav-toggle').off('click');
        $('.nav-link.scrollto').off('click');
      };
    }, [isMobile]); // Dependency on isMobile
  
    const [isScrolled, setIsScrolled] = useState(false);
  
    useEffect(() => {
      const handleScroll = () => {
        const scrollTop = window.scrollY;
        if (scrollTop > 50 && !isScrolled) {
          setIsScrolled(true);
        } else if (scrollTop <= 50 && isScrolled) {
          setIsScrolled(false);
        }
      };
      window.addEventListener('scroll', handleScroll);
  
      // Clean up the event listener on component unmount
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, [isScrolled]);



  return (

    <>
    <Header />
      <div style={{marginTop:'-34px'}} >

      <div class="inner-top-img-clr" ><div class="inner-top-img">
        <div class="inner-top-img-text section-title"><h2 style={{color:'rgb(255, 255, 255)'}}>Contact Us</h2></div></div></div>
              <div className="container mt-5 mb-5">
                  
                  <div className="row">

                      


                      <div className="col-lg-8 col-md-7 form-container">
                          <div>
                              <form onSubmit={handleSubmit} >
                                  <div className="row">
                                      <div className="col-md-6">
                                          <p>
                                             
                                              <input  name='name' value={name} onChange={(e)=>{setName(e.target.value)}}  type="text" placeholder='Name'  />
                                          
                                          </p>
                                      </div>
                                      <div className="col-md-6">
                                          <p>
                                             
                                              <input name='email' value={email} onChange={(e)=>{setEmail(e.target.value)}}  placeholder='Email'  />
        
                                          </p>
                                      </div>
                                      <div className="col-md-6">
                                          <p>
                                             
                                              <input name='phone' value={phone} onChange={(e)=>setPhone(e.target.value)}  placeholder='Phone number' />
                                            
                                          </p>
                                      </div>
                                      <div className="col-md-6">
                                          <p>
                                             
                                              <select value={developmentType}  onChange={(e)=>{setDevelopmentType(e.target.value)}}  
       
        required>
                                                  <option selected >What are you looking for?</option>
                                                  <option  value='ERP Development' >ERP Development</option>
                                                  <option value="CRM Development">CRM Development</option>
                                                  <option value="Web Development">Web Development</option>
                                                  <option value="Mobile Development">Mobile Development</option>
                                                  <option value="Restaurant Management">Restaurant Management</option>
                                                  <option value="Temple Management">Temple Management</option>
                                                  <option value="Boutique Management">Boutique Management</option>
                                                  <option value="Retail Management">Retail Management</option>
                                                  <option value="Billing & Invoice">Billing & Invoice</option>
                                              </select>
                                             
                                  
                                          </p>
                                      </div>
                                
                                      <div className="col-md-12">
                                          <p>
                                             
                                              <button type="submit" disabled={btnDisable}  className='btn btn-outline-dark btn-3d mt-3'>submit</button>
          
                                          </p>
                                      </div>
                                  </div>
                              </form>
                              {/* {message && <p>{message}</p>} */}
                          </div>
                      </div>
                      <div className="col-lg-4 col-md-5 mb-5" style={{background: 'rgb(233, 236, 239)',borderRadius:'10px'}}>
                          <h4 className='text-center mt-3' style={{ fontWeight:'bold'}}>Office Address</h4>
                          <h5 className='mt-3' style={{ fontWeight:'bold'}}>Kochi</h5>
                          <p className='contact-details'>
                          Thapasya Building<br />
                          Phase 1 , 4th floor Infopark TBC<br />
                          Room No 11 , Infopark<br />
                          Kochi P.O Kakkanad<br />
                          682042,Kerala
                        </p>
                        <h5 className='mt-3' style={{ fontWeight:'bold'}}>Vazhithala</h5>
                        <p className='contact-details'>
                          Sreyas City Plaza , <br /> 
                          Beside Thrikkekkunnu Sree Mahadeva Temple ,<br /> 
                          Vazhithala ,<br /> 
                          Kerala 685583
                        </p>
                      </div>
                  </div>
               
              </div>
          </div>

          <Footer />
          
          </>
  )
}

export default Contact